import type { Workspace } from "@/lib/workspace";

export interface ScopeLines {
  org: string;
  /** The project in view, or why there is none (`known: false`, set quieter). */
  project: { text: string; known: boolean };
}

/** The rail's scope block: the organization and the project in view, or why there is none. */
export function scopeLines({ organization, projects, project, user }: Workspace): ScopeLines {
  if (!organization) {
    return {
      org: "None yet",
      project: {
        text: user.platform_admin ? "Create an organization to begin" : "Ask an admin to add you",
        known: false,
      },
    };
  }
  const quiet = (text: string) => ({ org: organization.name, project: { text, known: false } });
  if (!projects || projects.isPending) return quiet("Loading");
  if (projects.isError) return quiet("Did not load");
  return project
    ? { org: organization.name, project: { text: project.name, known: true } }
    : quiet("None yet");
}
